package com.appsyde.shared.modules.team.domain.model

data class TeamUser(
    val id: String,
    val email: String,
    val role: String,
    val status: String,
    val createdAt: String,
    val updatedAt: String
)
